
import { Component, OnInit, TemplateRef, OnChanges, EventEmitter, ViewChild } from '@angular/core';
import { RequestdashboardService } from './requestdashboard.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, ModalOptions, BsModalRef } from 'ngx-bootstrap';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { QuerycommentsComponent } from '../../Shared/querycomments/querycomments.component';
import { QuerycommentsService } from '../../Shared/querycomments/querycomments.service';
import { UserService } from '../../Master/user/user.service';
import { User } from '../../Master/user/user';
import { requeststatus } from './requeststatus';
import { QuerycommentsmgtComponent } from '../../querycommentsmgt/querycommentsmgt.component';
declare let $: any;
import { RequestconfigService } from '../../configuration/requestconfig/requestconfig.service';
import { saveFile, saveAs } from 'file-saver';
import { NgxSpinnerService } from "ngx-spinner";
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { BusinessunitService } from '../../Master/businessunit/businessunit.service';
import { Product } from '../../Master/product/product';
import { ProductService } from '../../Master/product/product.service';
import { Observable, timer } from 'rxjs';
import { Location } from "@angular/common";
import { FormdashboardService } from '../formdashboard/formdashboard.service';
import { LocalService } from '../../local.service';
import {encryptdecrypt} from '../../encryptdecrypt';
@Component({
  selector: 'app-requestdashboard',
  templateUrl: './requestdashboard.component.html',
  styleUrls: ['./requestdashboard.component.css'],
  providers: [NgbTabset]
})


export class RequestdashboardComponent implements OnInit {
  @ViewChild('tabs', { static: false })
  private tabs: NgbTabset;

  sendMenuId: number = 30;
  sendPageName: string = 'Request Dashboard';
  // action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

 databaseId_Searchall: number = 0;								   
  databaseId: number = 0;
  request: any;
  requestlist: any = [];
  requestlisttmp: any = [];
  requestlistClosed: any = [];
  requestlistCancelled: any = [];
  requestlistOthers: any = [];
  requestlistOthers_SearchAll: any = [];										
  queryrequestdata: any = [];

  requeststatus: requeststatus = new requeststatus();
  databaseListTmp: any = [];
  databaseList: any = [];
  usermappedDatabase: any = [];
  selectedDaterange: any;
  dt: any = []; dt1: any = [];dt_searchall: any = []; dt1_searchall: any = [];
  businessUnitList: any = []; businessunitid: number;

 						   

  Users: User[];
  UserList: any = [];
  user: User;
  conversionuser: boolean = false;
  adminuser: boolean = false;
  operation: string;
  userid: number;
  confmsg: string;
  p: number = 1; q: number = 1; r: number = 1; searchText: string;
  itemsPerPage: number = 10;
  requestmapped: any = [];
  databaseidfromhome: number = 0;
  key: string = 'RequestDashboard'; // set default
  reverse: boolean = false;
  totalRequestCount: number = 0;
  selectedRequestType: string = 'others';
  columnshow: boolean = false;
  searchCondition: string = '';
  sortCondition: string = ''; _pageNumber: number = 0;
  state: any;
  searchConditionList: any = [];
  sortDirection: string = '';
  allowedit: boolean = false;
  allowedituserList: any = [];
  // timervaluerequest: Observable<Number> = timer(0,2*60000);
  subscription: any;
  productsList: Product[] = []; productId: number = 0;
	productId_Searchall: number = 0;							  
  todaydate = new Date();
  supportuser: boolean = false;
  removedaterangeflag: boolean = false;
  allrequestlist: any = [];
  s: number = 1;
  reqtypeModelRef: BsModalRef;
  SearchAllReqRef: BsModalRef;							  
  selReqType: number = 0;
  isitemperpagechanged: boolean = false;
  selectedDaterangeexcel: any;

  searchTextforDatabase: string;							
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    ignoreBackdropClick: true,
    class: 'modal-dialog-centered modal-customlarge'
  };




  headerKeyOthers = [
    'dbname',
    'requesttype',
    'samedayturnaround',
    'businessunit',
    'Document',
    'productname',
    'prodname',
    'desiredfilename',
    'desiredcompletiondate',
    'Pickedby',
    'team',
    'createdonformatted',
    'createdbyname',
    'status'
  ];
  p_searchall: number = 1;  totalRequestCount_searchall: number = 0; businessunitId_Searchall: number=0;	
  selectedDaterange_searchall: any;removedaterangeflag_searchall: boolean = false;searchCondition_searchall:string='';
  columnshow_searchall: boolean = false;sortDirection_searchall:string='';sortCondition_searchall:string='';
  headerKeyClosed = [
    'dbname',
    'requesttype',
    'samedayturnaround',
    'businessunit',
    'Document',
    'productname',
    'prodname',
    'desiredfilename',
    'desiredcompletiondate',
    'Pickedby',
    'team',
    'createdonformatted',
    'createdbyname',
    'status',
    'finalupload',
    'finaluploadsupportingfiles'
  ];
  enc=new encryptdecrypt();
  constructor(
    private requestdashboardservice: RequestdashboardService,
    private querycommentsservice: QuerycommentsService,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    private route: ActivatedRoute,
    private userservice: UserService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private requestConfigService: RequestconfigService, private SpinnerService: NgxSpinnerService, private datePipe: DatePipe, public tabset: NgbTabset,
    private businessunitService: BusinessunitService, private productService: ProductService, 
    private location: Location, private formdashboardservice: FormdashboardService,
    private localService: LocalService
) {
    // code to get relavent menu id
    // if (this.router.getCurrentNavigation().extras.state != undefined) {
    //  localStorage.setItem('RequestDashboard_menuid', this.router.getCurrentNavigation().extras.state.menuid);
    //  localStorage.setItem('RequestDashboard_action', this.router.getCurrentNavigation().extras.state.action);
    //  this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
    //  this.sendMenuId = this._menuId;
    //  this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    // }
    // else {
    //  if (this._menuId == undefined)
    //    this._menuId = localStorage.getItem('RequestDashboard_menuid');
    //  this.sendMenuId = this._menuId;
    //  if (this._actionRights == undefined)
    //    this._actionRights = localStorage.getItem('RequestDashboard_action');
    // }
    const navigation = this.router.getCurrentNavigation();
    this.state = navigation.extras.state as {
      selectedDataBase: any;
      userType: any;
      selectedColumnShow: any;
      selectedReqType: any;
      selectedPageNumber: any;
      selectedItemsPerPage: any;
      selectedSearchCondition: any;
      selectedSortCondition: any;
      selectedSearchConditionList: any;
    };
    if (this.state != null && this.state != undefined) {
      if (this.state.selectedDataBase != undefined && this.state.selectedDataBase != 'NaN') {
        this.databaseidfromhome = this.state.selectedDataBase;
        this.databaseId = this.state.selectedDataBase;
      }
      else {
        this.databaseidfromhome = 0;
        this.databaseId = 0;
      }
      this.adminuser = this.state.userType;
      this.columnshow = this.state.selectedColumnShow;
      this.selectedRequestType = this.state.selectedReqType;
      this.itemsPerPage = this.state.selectedItemsPerPage == undefined ? 10 : this.state.selectedItemsPerPage;
      this.searchCondition = this.state.selectedSearchCondition;
      this.sortCondition = this.state.selectedSortCondition;
      if (this.selectedRequestType == 'others') {
        this.p = this.state.selectedPageNumber == undefined ? 1 : this.state.selectedPageNumber;
      }
      else if (this.selectedRequestType == 'closed') {
        this.q = this.state.selectedPageNumber == undefined ? 1 : this.state.selectedPageNumber;
      }
      else {
        this.r = this.state.selectedPageNumber == undefined ? 1 : this.state.selectedPageNumber;
      }
      if (this.state.selectedSearchConditionList != undefined && this.state.selectedSearchConditionList != null) {
        this.searchConditionList = JSON.parse(this.state.selectedSearchConditionList);
      }
    }
  }

  comments(request: any) {
    var config: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      animated: true,
      ignoreBackdropClick: true,
      class: 'modal-custom',
      initialState: {
        requestdetailid: request.requestid,
        requesttypeid: request.requesttypeid,
        popupflag: 1
      }
    };
    this.bsModalRef = this.modalService.show(QuerycommentsmgtComponent, config);
    this.bsModalRef.content.closeBtnName = 'Close';
    this.bsModalRef.content.closeSubject.subscribe(result => {
      this.requestlist = [];
      this.requestlistClosed = [];
      this.requestlistCancelled = [];
      this.requestlistOthers = [];
      this.requestlisttmp = [];
      var dbid = $("#dbid option:selected").val();
      this.getqueryData();
      // this.getAll(dbid);
      this.getRequestDetails(this.selectedRequestType, 0);
    });
  }

  async ngOnInit() {

    this.SpinnerService.show();
    // this.route.params.subscribe(params => {
    //  this.databaseidfromhome = +params['db'];
    // });
    this.route.params.subscribe(params => {
      this.databaseidfromhome =+this.enc.decryptUsingAES256(params['db'].toString());// +params['db'];
      this.databaseId =+this.enc.decryptUsingAES256(params['db'].toString());// +params['db'];
    });

    this.searchText = '';
    this.getpagepreference();

    this.loadDatabaseList();
    this.loadBusinessUnit();
    // this.getusers();
    // for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
    this.geteditableuserList();
    this.getProducts();

    // this.subscription = this.timervaluerequest.subscribe(res => {

    // // this.getRequestDetails(this.selectedRequestType);
    //  if (this.location.path() == '/home/requestdashboard') {
    //    this.getRequestDetails(this.selectedRequestType,0);
    //  }

    // });


    const currentDate = await this.getCurrentDate();

    this.todaydate = new Date(currentDate);
    // this.selectedDaterange = [new Date(new Date().setMonth(this.todaydate.getMonth() - 3)), this.todaydate];
  }
  async getCurrentDate() {
    return await this.requestConfigService.GetServerDate().toPromise().then(res => res.date);
  }
  sort(key) {
    if (this.key != key) {
      this.sortDirection = '';
      this.sortDirection = 'asc';
    }
    else {
      this.sortDirection = this.sortDirection === 'desc' ? 'asc' : 'desc';
    }
    this.key = key;
    this.reverse = !this.reverse;
    this.sortCondition = '';

    // this.sortCondition = 'l.' + this.key.toLowerCase() + ' ' + this.sortDirection;
    if (this.key == 'createdonformatted') {
      this.sortCondition = 'l.createdon' + ' ' + this.sortDirection;
    }
    else if (this.key == 'desiredcompletiondate'){
      this.sortCondition = 'l.desiredcompletiondatenotformated' + ' ' + this.sortDirection;
    }
    else {
      this.sortCondition = 'l.' + this.key.toLowerCase() + ' ' + this.sortDirection;
    }

    this.getRequestDetails(this.selectedRequestType, 0);
  }

	  
  loadBusinessUnit() {
    this.businessunitService.GetActives().subscribe(res => { this.businessUnitList = res; },
      err => { this.toastr.error('Error while getting BusinessUnit data'); });
  }

  businessunitchange(event) {

    this.businessunitid = event.target.value;
    var selectedValue = event.target.value;

    this.getRequestDetails(this.selectedRequestType, 0);

  }

  geteditableuserList() {
    this.userservice.GetEditableUser().subscribe(res => {
      var tempalloweditdata = res.filter(e => e.userid == this.userid);
      if (tempalloweditdata != null && tempalloweditdata != undefined && tempalloweditdata.length != 0)
        this.allowedit = true;
      else
        this.allowedit = false;
    });
  }


  // assigning value from menu rights button
  getActionRightsList() {

    this.userservice.Get().subscribe(res => {

      let allUser: any = [];
      allUser = res.find(y => y.userid == this.userid);
      var data = JSON.parse(allUser.menumapped);
      if (data != null && data != undefined && data.length != 0) {
        data = data.filter(e => e.menuid == this.sendMenuId);
        if (data != null && data != undefined && data.length != 0)
          this._actionRights = data[0].action;
        else
          this._actionRights = [];

      }

      var btnToEnable = this._actionRights;
      if (btnToEnable.length > 0) {
        btnToEnable.forEach(d => {
          if (d != undefined) {
            if (d == 1)
              this.readOnly = true;
            else if (d == 2) {
              this.readOnly = true;
              this.add = true;
              this.submitShow = true;
            }
            else if (d == 3) {
              this.readOnly = true;
              this.edit = true;
              // this.submitShow = true;
            }
            else if (d == 4) {
              this.readOnly = true;
              this.delete = true;
            }
          }
        });
      }
    });
  }

  statusupdate(request, status, redirect) {

    if (redirect == 'check') {
      if (request.pickedbyuserid == this.userid || request.supportpickedbyuserid == this.userid) {
        // this.router.navigate(['/home/requestconfig'], { queryParams: { requestid: request.requestid, requesttypeid: request.requesttypeid, redirectmode: 'conversionuser', conversionuser: this.conversionuser } })
        let queryParams = {};
        queryParams['requestid'] =this.enc.encryptUsingAES256(request.requestid.toString());
        queryParams['requesttypeid'] = this.enc.encryptUsingAES256(request.requesttypeid.toString());
        // queryParams['redirectmode'] = 'conversionuser';
        // queryParams['conversionuser'] = this.conversionuser;

        if (this.supportuser && request.statusid == 15) {
          queryParams['redirectmode'] = this.enc.encryptUsingAES256('supportuser');
          queryParams['supportuser'] = this.enc.encryptUsingAES256(this.supportuser.toString());
        }
        else {
          queryParams['redirectmode'] = this.enc.encryptUsingAES256('conversionuser');
          queryParams['conversionuser'] = this.enc.encryptUsingAES256(this.conversionuser.toString());
        }

        const navigationExtras: NavigationExtras = {
          queryParams,
          state: {
            selectedDataBase: this.databaseId,
            userType: this.adminuser,
            selectedColumnShow: this.columnshow,
            selectedReqType: this.selectedRequestType,
            selectedPageNumber: this._pageNumber,
            selectedItemsPerPage: this.itemsPerPage,
            selectedSearchCondition: this.searchCondition,
            selectedSortCondition: this.sortCondition,
            selectedSearchConditionList: JSON.stringify(this.searchConditionList)
          }
        };
        this.router.navigate(['/home/requestconfig'], navigationExtras);
		 this.SearchAllReqRef.hide();							
      }
    }
    else {
      this.requeststatus.requestdetailid = request.requestid;
      this.requeststatus.requesttypeid = request.requesttypeid;
      this.requeststatus.active = 1;
      this.requeststatus.statusid = status;
      this.requeststatus.createdby = this.userid;
      // this.SpinnerService.show();
      this.requestdashboardservice.Post(this.requeststatus).subscribe(
        (res) => {
          if (res.body != 0) {

            if (redirect == 'yes') {
              let queryParams = {};
              queryParams['requestid'] = this.enc.encryptUsingAES256(request.requestid.toString());
              queryParams['requesttypeid'] = this.enc.encryptUsingAES256(request.requesttypeid.toString());
              // queryParams['redirectmode'] = 'conversionuser';
              // queryParams['conversionuser'] = this.conversionuser;
              // if (this.supportuser && request.statusid == 1) {
              //  queryParams['redirectmode'] = 'supportuser';
              //  queryParams['supportuser'] = this.supportuser;
              // }
              // else {
              //  queryParams['redirectmode'] = 'conversionuser';
              //  queryParams['conversionuser'] = this.conversionuser;
              // }

              if ((request.statusid === 16 && this.conversionuser && request.supportusercheckcount == 1 && request.supportusercheckrequestcount == 0) || (request.statusid === 1 && this.conversionuser && request.supportusercheckrequestcount == 0) || (request.statusid === 16 && this.conversionuser && request.supportusercheckcount == 1 && request.supportusercheckrequestcount == 1) || request.statusid == 4) {
                queryParams['redirectmode'] = this.enc.encryptUsingAES256('conversionuser');
                queryParams['conversionuser'] = this.enc.encryptUsingAES256(this.conversionuser.toString());
              } else {
                queryParams['redirectmode'] =this.enc.encryptUsingAES256('supportuser');
                queryParams['supportuser'] = this.enc.encryptUsingAES256(this.supportuser.toString());
              }
              const navigationExtras: NavigationExtras = {
                queryParams,
                state: {
                  selectedDataBase: this.databaseId,
                  userType: this.adminuser,
                  selectedColumnShow: this.columnshow,
                  selectedReqType: this.selectedRequestType,
                  selectedPageNumber: this._pageNumber,
                  selectedItemsPerPage: this.itemsPerPage,
                  selectedSearchCondition: this.searchCondition,
                  selectedSortCondition: this.sortCondition,
                  selectedSearchConditionList: JSON.stringify(this.searchConditionList)
                }
              };
              this.router.navigate(['/home/requestconfig'], navigationExtras);
			   this.SearchAllReqRef.hide();							  
              // this.router.navigate(['/home/requestconfig'], { queryParams: { requestid: request.requestid, requesttypeid: request.requesttypeid, redirectmode: 'conversionuser', conversionuser: this.conversionuser } })
            }
            else if (redirect == 'reopen') {
              let queryParams = {};
              queryParams['requestid'] = this.enc.encryptUsingAES256(request.requestid.toString());
              queryParams['requesttypeid'] = this.enc.encryptUsingAES256(request.requesttypeid.toString());
              queryParams['redirectmode'] = this.enc.encryptUsingAES256('normaluser');
              const navigationExtras: NavigationExtras = {
                queryParams,
                state: {
                  selectedDataBase: this.databaseId,
                  userType: this.adminuser,
                  selectedColumnShow: this.columnshow,
                  selectedReqType: this.selectedRequestType,
                  selectedPageNumber: this._pageNumber,
                  selectedItemsPerPage: this.itemsPerPage,
                  selectedSearchCondition: this.searchCondition,
                  selectedSortCondition: this.sortCondition,
                  selectedSearchConditionList: JSON.stringify(this.searchConditionList)
                }
              };
              this.router.navigate(['/home/requestconfig'], navigationExtras);
				 this.SearchAllReqRef.hide();						  
              // this.router.navigate(['/home/requestconfig'], { queryParams: { requestid: request.requestid, requesttypeid: request.requesttypeid, redirectmode: 'normaluser' } })
            }
            else {
              this.requestlist = [];
              this.requestlistClosed = [];
              this.requestlistCancelled = [];
              this.requestlistOthers = [];
              this.requestlisttmp = [];
              var dbid = $("#dbid option:selected").val();
              // this.getAll(dbid);
              this.getRequestDetails(this.selectedRequestType, 0);
            }
          }
        }, error => {
          this.toastr.error("Error while updating status");
          //  this.SpinnerService.hide();
        });
    }
  }

  getqueryData() {
    this.querycommentsservice.Get().toPromise().then(res => {
      if (res != undefined) {
        if (res.length > 0) {
          this.queryrequestdata = res;
        }
      }
    });
  }

  getColor(request) {

    if (request.statusid == 3) {

      var filterResult: any = [];
      var repliedfilterResult: any = [];
      this.queryrequestdata.forEach(data => {
        if (data.requestdetailid == request.requestid && data.requesttypeid == request.requesttypeid
          && data.parent == 0 && data.type == 'query')
          filterResult.push(data);
      });

      if (filterResult != undefined && filterResult.length > 0) {
        filterResult.forEach(data => {
          if (data.replycomments == null)
            repliedfilterResult.push(data);
        });
        if (repliedfilterResult != undefined && repliedfilterResult.length > 0)
          return 'red';
        else
          return 'green';
      }
      return 'red';
    }
    else
      return ' ';
  }

  dbonChange(eve) {
    this.databaseId = eve.target.value;
    var selectedValue = eve.target.value;
    this.requestlist = [];
    this.requestlistClosed = [];
    this.requestlistCancelled = [];
    this.requestlistOthers = [];
    this.requestlisttmp = [];
    this.columnshow = false;
    this.searchConditionList = [];
    //
    // this.getAll(selectedValue);
    this.getRequestDetails(this.selectedRequestType, 0);
  }

  loadDatabaseList() {
    this.getqueryData();
    //this.userid = +localStorage.getItem("userid");
       let a= new encryptdecrypt();
    this.userid = +this.localService.getJsonValue("userid");
    this.userservice.Get().toPromise().then(res => {

       res.forEach((data: any) => {
        data.firstname = a.decryptUsingAES256(data.firstname);
        data.lastname = a.decryptUsingAES256(data.lastname);
        data.emailid = a.decryptUsingAES256(data.emailid);
      });
      
      this.Users = res;
      this.UserList = this.Users.find(y => y.userid == this.userid);
      var userdata = this.UserList;
      if ((userdata.reviewmapped != null)) {
        var reviewmapped = JSON.parse(userdata.reviewmapped);
        if (reviewmapped.reviewmapped.length) {
          this.supportuser = true;
        }
        else {
          this.supportuser = false;
        }
      }

      if ((userdata.requestmapped != null)) {
        var request1 = JSON.parse(userdata.requestmapped);
        if (request1.requestmapped.length) {
          this.conversionuser = true;
        }
        else {
          this.conversionuser = false;
        }
        this.requestmapped = userdata.requestmapped;
      }
      if (userdata.userrole == "Admin") {
        this.adminuser = true;
      }
      else {
        this.adminuser = false;
      }
      this.usermappedDatabase = JSON.parse(userdata.databasemapped).databasemapped;

      this.requestdashboardservice.getActivedatabase().toPromise().then(res => {
        var allData = res;
        allData.forEach(data => {
          this.usermappedDatabase.forEach(a => {
            if (data.databaseid == a.databaseid) {
              this.databaseListTmp.push({ databaseid: data.databaseid, database: data.database });
            }
          });
        });
        this.databaseList = JSON.parse(JSON.stringify(this.databaseListTmp));

        if (this.state != null && this.state != undefined) {
          this.databaseidfromhome = this.state.selectedDataBase;
          this.databaseId = this.state.selectedDataBase;
          this.getRequestDetails(this.selectedRequestType, 0);
        }
        else {
          this.getRequestDetails(this.selectedRequestType, 0);
          // if (this.databaseidfromhome > 0)
          //  this.getAll(this.databaseidfromhome);
          // else {
          //  //this.getAll(0);
          //  this.getRequestDetails(this.selectedRequestType);
          //  }
        }

      }, error => { this.toastr.error('Error while getting the database data'); });

    });
  }


  getPage(page: number) {
    if (this.selectedRequestType == 'others') {
      this.p = page;
    } else if (this.selectedRequestType == 'closed') {
      this.q = page;
    } else if (this.selectedRequestType == 'cancelled') {
      this.r = page;
    } else if (this.selectedRequestType == 'allrequests') {
      this.s = page;
    }

    this.getRequestDetails(this.selectedRequestType, 0);
  }





  OpenConfirmTemplate(request, template: TemplateRef<any>) {

    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to cancel this request ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.request = request;
          var msg = 'Request Cancelled Successfully';
          //this.userid = +localStorage.getItem("userid");
          this.userid = +this.localService.getJsonValue("userid");
          this.statusupdate(request, 6, 'no');
        }

      });

  }

  editRequest(request) {

    let a = request.requestid + '*' + request.requesttypeid;
    let queryParams = {};
   // let e= new encryptdecrypt();
    queryParams['requestid'] = this.enc.encryptUsingAES256(request.requestid.toString());//request.requestid;
    queryParams['requesttypeid'] = this.enc.encryptUsingAES256(request.requesttypeid.toString());//request.requesttypeid;
    queryParams['redirectmode'] =this.enc.encryptUsingAES256('normaluser');// 'normaluser';
    const navigationExtras: NavigationExtras = {
      queryParams,
      state: {
        selectedDataBase: this.databaseId,
        userType: this.adminuser,
        selectedColumnShow: this.columnshow,
        selectedReqType: this.selectedRequestType,
        selectedPageNumber: this._pageNumber,
        selectedItemsPerPage: this.itemsPerPage,
        selectedSearchCondition: this.searchCondition,
        selectedSortCondition: this.sortCondition,
        selectedSearchConditionList: JSON.stringify(this.searchConditionList)
      }
    };
    this.router.navigate(['/home/requestconfig'], navigationExtras);
	this.SearchAllReqRef.hide();							

    // let a = request.requestid + '*' + request.requesttypeid
    // this.router.navigate(['/home/requestconfig'], { queryParams: { requestid: request.requestid, requesttypeid: request.requesttypeid, redirectmode: 'normaluser' } })
  }

  clearForm() {

    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.bsModalRef.hide();
  }

  getAll(dbid) {
    // this.SpinnerService.show();
    this.requestlistClosed = [];
    this.requestlistCancelled = [];
    this.requestlistOthers = [];
    // others
    this.requestdashboardservice.GetAll().toPromise().then(res => {

      // this.requestlist = res;
      var databasedetails = this.databaseListTmp;
      var allData = res;
      allData.forEach(data => {
        databasedetails.forEach(a => {
          if (data.dbid == a.databaseid) {
            this.requestlist.push(data);
          }
        });
      });

      // this.getrequest(this.requestlist, 'Others', dbid);
      // closed
      ////  this.getrequest(this.requestlist, 'Closed', dbid);
      // Cancelled
      // this.getrequest(this.requestlist, 'Cancelled', dbid);
    }, error => { this.toastr.error('Error while getting Request data'); });

  }



  viewrequest(request) {
    // let a = request.requestid + '*' + request.requesttypeid
    // this.router.navigate(['/home/requestconfig'], { queryParams: { requestid: request.requestid, requesttypeid: request.requesttypeid, redirectmode: 'viewrequest' } })
    let a = request.requestid + '*' + request.requesttypeid;
    let queryParams = {};
    //let e= new encryptdecrypt();
    queryParams['requestid'] =this.enc.encryptUsingAES256(request.requestid.toString());// request.requestid;
    queryParams['requesttypeid'] =this.enc.encryptUsingAES256(request.requesttypeid.toString());// request.requesttypeid;
    queryParams['redirectmode'] = this.enc.encryptUsingAES256('viewrequest');//'viewrequest';
    const navigationExtras: NavigationExtras = {
      queryParams,
      state: {
        selectedDataBase: this.databaseId,
        userType: this.adminuser,
        selectedColumnShow: this.columnshow,
        selectedReqType: this.selectedRequestType,
        selectedPageNumber: this._pageNumber,
        selectedItemsPerPage: this.itemsPerPage,
        selectedSearchCondition: this.searchCondition,
        selectedSortCondition: this.sortCondition,
        selectedSearchConditionList: JSON.stringify(this.searchConditionList)
      }
    };
    this.router.navigate(['/home/requestconfig'], navigationExtras);
	 this.SearchAllReqRef.hide();							
  }


  fileDownloadrequest(request, fileName, type) {
    this.SpinnerService.show();
    // var s = this.databases.filter(e => e.databaseid == request.dbid)
    // if (s != undefined && s != null && s.length != 0) {
    var requesttype = '';
    if (request.requesttypeid == 1)
      requesttype = 'courtagoopinionrequest';
    if (request.requesttypeid == 2)
      requesttype = 'researchgrouprequest';
    if (request.requesttypeid == 3)
      requesttype = 'informationrequest';
    if (request.requesttypeid == 4)
      requesttype = 'internetdownloadrequest';
    if (request.requesttypeid == 5)
      requesttype = 'conversionrequest';

    // add the line starts

    let requestData: any = [];
    requestData.push({
      'requesttype': requesttype, 'dbname': request.dbname, 'requestid': request.requestid, 'fileName': fileName, 'type': type
    });

    request.finalupload = request.finalupload == null ? '' : request.finalupload;
    request.finaluploadsupportingfiles = request.finaluploadsupportingfiles == null ? '' : request.finaluploadsupportingfiles;

    let a = request.finalupload.split(/(?<=\.[a-z]+):/g);
    let b = request.finaluploadsupportingfiles.split(/(?<=\.[a-z]+):/g);

    if (a.length > 1 || b.length > 1) {




      if (type == 'finaloutput')
        requestData[0].fileName = requesttype + '_' + request.requestid;
      else {
        if (b.length > 1)
          requestData[0].fileName = requesttype + 'finalsupporting' + '_' + request.requestid;
      }

      // requestData[0].fileName = requesttype + '_' + request.requestid;

      fileName = requestData[0].fileName;
      this.requestConfigService.DownloadFileRequestWithSpecialCharactersasZIP(requestData[0]).subscribe(res => {
        var content = res.body.file;
        let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
        saveAs(objectURL, fileName + '.zip');
        this.SpinnerService.hide();
      },
        error => {
          this.toastr.error('File not found');
          this.SpinnerService.hide();
        });

    } else {
      this.requestConfigService.DownloadFileRequestWithSpecialCharacters(requestData[0]).subscribe(res => {
        var content = res.body.file;
        let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
        saveAs(objectURL, fileName);
        this.SpinnerService.hide();
      },
        error => {
          this.toastr.error('File not found');
          this.SpinnerService.hide();
        });

    }

    // add the line ends

    // comment the line starts

    // this.requestConfigService.DownloadFileRequest(request.dbname, requesttype, request.requestid, type, request.finalupload).subscribe(res => {
    //  var content = res.file;
    //  let objectURL = 'data:application/octet-stream;base64,' + res.file;
    //  saveAs(objectURL, request.finalupload);
    // });
    // }

    // comment the line ends
  }
  ExportTOExcel(type) {
    // let _requestlist: any = [];
    this.SpinnerService.show();
    var databaseId = 0;
    if (this.databaseId > 0) {
      databaseId = this.databaseId;

    }
    else {
      databaseId = 0;
    }
    let userId: number = 0;
    userId = this.userid;

    // if (this.adminuser == true) {
    //  userId = 0;
    // }
    // else {
    //  userId = this.userid;
    // }



    var daterange = '';
    // let daterangevalue = type == 'Downloadllfields' ? this.selectedDaterangeexcel : this.selectedDaterange;
    let daterangevalue = this.selectedDaterange;
    if (daterangevalue != undefined && daterangevalue.length != 0) {
      // daterange = 'to_char(l.createdon:: timestamp, "mm/dd/yyyy") between ' + '"' + this.datePipe.transform(this.selectedDaterange[0], "MM/dd/yyyy") + '"' + ' and ' + '"' + this.datePipe.transform(this.selectedDaterange[1], "MM/dd/yyyy") + '"';
     // daterange = 'cast(l.createdon as date) between ' + '"' + this.datePipe.transform(daterangevalue[0], "MM/dd/yyyy") + '"' + ' and ' + '"' + this.datePipe.transform(daterangevalue[1], "MM/dd/yyyy") + '"';
     daterange ='  to_date(to_char(l.createdon, "MM/DD/YYYY"), "MM/DD/YYYY") between to_date(' + '"' + this.datePipe.transform(daterangevalue[0], "MM/dd/yyyy") + '"' + ',"MM/DD/YYYY") and to_date(' + '"' + this.datePipe.transform(daterangevalue[1], "MM/dd/yyyy") + '"'  + ',"MM/DD/YYYY")';

    }
    else {
      daterange = null;
    }




    let input: any = [];
    var businessunitId = 0;
    if (this.businessunitid > 0) {
      businessunitId = this.businessunitid;
    }
    else {
      businessunitId = 0;
    }
    var productId = 0;
    if (this.productId > 0) {
      productId = this.productId;
    }
    else {
      productId = 0;
    }
    var searchConditiontmp = '';
    if (this.searchCondition != '') {
      searchConditiontmp = this.searchCondition;
    }
    else {
      searchConditiontmp = null;
    }

    var sortConditiontmp = '';
    if (this.sortCondition != '') {
      sortConditiontmp = this.sortCondition;
    }
    else {
      sortConditiontmp = null;
    }


    //if (type == 'Downloadllfields') {
    //  searchConditiontmp = null;
    //  sortConditiontmp = null;
    //}
    let isdownloadallfields = type == 'Downloadllfields' ? true : false;
    input.push({
      requesttype: this.selReqType, status: 0, active: 0, mode: 'exporttoexcel', pageno: 0, itemsperpage: 0, searchcondition: searchConditiontmp, sorting: sortConditiontmp,
      requeststatus: this.selectedRequestType, dbid: databaseId, userid: userId, daterange: daterange, businessunitid: businessunitId, productid: productId, isdownloadallfields: isdownloadallfields
    });
    let list: any = [];
    this.requestdashboardservice.getRequestDashboardExportToExcel(input[0]).toPromise().then(res => {
      if (res != undefined && res != null && res.body != undefined && res.body != null && res.body.length != 0) {
        list = res.body;

        if (list.length != 0) {
          var finaloutput = [];

          if (type == 'Downloadllfields') {
            finaloutput = list[0].sprequestconfigselectallfields != null ? JSON.parse(list[0].sprequestconfigselectallfields) : [];
          } else {
            finaloutput = list.map(elm => ({
              'Database Name': elm.dbname, 'Request Type': elm.requesttype, 'Business Unit': elm.businessunit, 'Document': elm.document, 'Product Acronym': elm.prodname, 'Product Name': elm.productname,
              'Desired File Name': elm.desiredfilename, 'Desired Completion Date': elm.desiredcompletiondate, 'Picked By': elm.pickedby, 'Team': elm.team, 'Raised On': elm.createdonformatted, 'Raised By': elm.createdbyname, 'Status': elm.status,
              'Final Output': elm.finalupload
            }));
          }


          list = [];
          list = finaloutput;
        }
        if (list.length > 0) {
          list.map(function (obj) {
            delete obj.requestid; delete obj.requesttypeid;
            delete obj.active; delete obj.createdby; delete obj.dbid; delete obj.pickedbyuserid; delete obj.statusid; delete obj.pickbyusercheck;
          });
          var today = new Date();
          var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
          var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
          var dateTime = date + ' ' + time;
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(list);
          const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
          const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
         // this.saveAsExcelFile(excelBuffer, 'Request Dashboard' + '-' + dateTime + '.xlsx');
          let filename = '';
          let requesttypes = [
            'CourtAgoOpinion Request',
            'ResearchGroup Request',
            'Information Request',
            'InternetDownload Request',
            'Conversion Request'
          ];
          if (type == 'Downloadllfields') {
            filename = requesttypes[this.selReqType - 1];
          } else {
            filename = 'Request Dashboard';
          }
          this.saveAsExcelFile(excelBuffer, filename + '-' + dateTime + '.xlsx');

          this.SpinnerService.hide();
        } else {
          this.toastr.error('No data to download');
          this.SpinnerService.hide();
        }
      }
      else {
        this.toastr.error('No data to download');
        this.SpinnerService.hide();
      }
    }, err => {
      this.toastr.error('Error while exporting the details');
      this.SpinnerService.hide();
    });
  }






  getrequestexporttoexcel(data, type, dbid) {
    let _requestlisttmp: any = []; let _requestlistOthers: any = []; let _requestlistCancelled: any = []; let _requestlistClosed: any = [];
    data.forEach(data => {
      // conversion user
      if (this.conversionuser == true) {

        var request = JSON.parse(this.requestmapped);
        for (var i = 0; i < request.requestmapped.length; i++) {

          if (dbid == 0) {
            if (data.status == type && data.requesttypeid == request.requestmapped[i].requesttypeid) {
              _requestlisttmp.push(data);
            }
            else if (type == 'Others' && data.status != "Cancelled" && data.status != "Closed" && data.requesttypeid == request.requestmapped[i].requesttypeid) {
              _requestlisttmp.push(data);
            }
          }
          else {
            if (data.status == type && data.dbid == dbid && data.requesttypeid == request.requestmapped[i].requesttypeid) {
              _requestlisttmp.push(data);
            }
            else if (type == 'Others' && data.status != "Cancelled" && data.status != "Closed" && data.dbid == dbid && data.requesttypeid == request.requestmapped[i].requesttypeid) {
              _requestlisttmp.push(data);
            }
          }

        }
      }
      // admin user
      else if (this.adminuser == true) {
        if (dbid == 0) {
          if (data.status == type) {
            _requestlisttmp.push(data);
          }
          else if (type == 'Others' && data.status != "Cancelled" && data.status != "Closed") {
            _requestlisttmp.push(data);
          }
        }
        else {
          if (data.status == type && data.dbid == dbid) {
            _requestlisttmp.push(data);
          }
          else if (type == 'Others' && data.status != "Cancelled" && data.status != "Closed" && data.dbid == dbid) {
            _requestlisttmp.push(data);
          }
        }
      }


      // other user
      else {
        if (dbid == 0) {
          if (data.status == type && data.createdby == this.userid) {
            _requestlisttmp.push(data);
          }
          else if (type == 'Others' && data.status != "Cancelled" && data.status != "Closed" && data.createdby == this.userid) {
            _requestlisttmp.push(data);
          }
        }
        else {

          if (data.status == type && data.dbid == dbid && data.createdby == this.userid) {
            _requestlisttmp.push(data);
          }
          else if (type == 'Others' && data.status != "Cancelled" && data.status != "Closed" && data.dbid == dbid && data.createdby == this.userid) {
            _requestlisttmp.push(data);
          }
        }
      }

    });

    if (type == 'Closed') {
      _requestlistClosed = _requestlisttmp;
      return _requestlistClosed;
    }
    if (type == 'Cancelled') {
      _requestlistCancelled = _requestlisttmp;
      return _requestlistCancelled;
    }
    if (type == 'Others') {

      _requestlisttmp.forEach(item => {
        var usercheck = 'no';
        var supportusercheck = 'no';
        if (item.pickedbyuserid == this.userid) {
          usercheck = 'yes';
        }
        if (item.supportpickedbyuserid == this.userid) {
          supportusercheck = 'yes';
        }
        item["pickbyusercheck"] = usercheck;
        item["supportusercheck"] = supportusercheck;

      });
      _requestlistOthers = _requestlisttmp;
      return _requestlistOthers;
    }



  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    var link = document.createElement("a");
    link.download = fileName;
    var url = window.URL.createObjectURL(data);
    link.href = url;
    document.body.appendChild(link);
    link.download = fileName;
    link.click();
    document.body.removeChild(link);
    self.close();
  }

  selectedRequestDateRange(eve) {
    this.selectedDaterange = eve;
    this.getRequestDetails(this.selectedRequestType, 0);
  }
  removeDateRange() {
    this.removedaterangeflag = true;
    this.selectedDaterange = [];
    this.getRequestDetails(this.selectedRequestType, 0);
  }
  changeitemsperpage(eve) {
    this.SpinnerService.show();
    if (this.isitemperpagechanged) {
      this.addpagepreference(eve.currentTarget.value);
    }
    this.itemsPerPage = +eve.currentTarget.value;
    this.p = 1; this.q = 1; this.r = 1;
    this.getRequestDetails(this.selectedRequestType, 0);
    this.SpinnerService.hide();
  }
  getRequestDetails(type, tabflag) {
    this.SpinnerService.show();
    if (this.selectedRequestType != '') {
      if (this.selectedRequestType != type) {
        this.searchCondition = '';
        this.sortCondition = '';
        this.columnshow = false;
        this.searchConditionList = [];
        this.p = 1; this.q = 1; this.r = 1;
        this.s = 1;
      }
    }
    
    if (this.columnshow == false) {
      this.searchCondition = '';
      this.searchConditionList = [];
    }



    // this.selectedRequestType = '';
    this.selectedRequestType = type;
    if (tabflag == 1) {
      if (this.selectedRequestType == 'closed') {
        this.selectedDaterange = [new Date(new Date().setMonth(this.todaydate.getMonth() - 3)), this.todaydate];
        this.removedaterangeflag == false;
      }
      else
        this.selectedDaterange = null;
    }



    var pagenumber = 0; var databaseId = 0;
    if (this.selectedRequestType == 'others') {
      pagenumber = this.p;
      this.tabs.select('OthersRequestList');
    }
    else if (this.selectedRequestType == 'closed') {
      pagenumber = this.q;
      this.tabs.select('ClosedRequestList');
      if (this.removedaterangeflag == true && tabflag == 0)
        this.selectedDaterange = null;
      else {
        if (tabflag == 1)
          this.selectedDaterange = [new Date(new Date().setMonth(this.todaydate.getMonth() - 3)), this.todaydate];
      }
    } else if (this.selectedRequestType == 'allrequests') {
      pagenumber = this.s;
      this.tabs.select('AllRequestList');
    }
    else {
      pagenumber = this.r;
      this.tabs.select('CancelledRequestList');
    }
    this._pageNumber = pagenumber;
    if (this.databaseId > 0) {
      databaseId = this.databaseId;
    }
    else {
      databaseId = 0;
    }

    var dateRange = '';
    if (this.selectedDaterange != undefined && this.selectedDaterange.length != 0) {
      // daterange = 'to_char(l.createdon:: timestamp, "mm/dd/yyyy") between ' + '"' + this.datePipe.transform(this.selectedDaterange[0], "MM/dd/yyyy") + '"' + ' and ' + '"' + this.datePipe.transform(this.selectedDaterange[1], "MM/dd/yyyy") + '"';
     // dateRange = ' to_char(cast(l.createdon as date),"MM/DD/YYYY") between ' + '"' + this.datePipe.transform(this.selectedDaterange[0], "MM/dd/yyyy") + '"' + ' and ' + '"' + this.datePipe.transform(this.selectedDaterange[1], "MM/dd/yyyy") + '"';
     dateRange = '  to_date(to_char(l.createdon, "MM/DD/YYYY"), "MM/DD/YYYY") between to_date(' + '"' + this.datePipe.transform(this.selectedDaterange[0], "MM/dd/yyyy") + '"' + ',"MM/DD/YYYY") and to_date(' + '"' + this.datePipe.transform(this.selectedDaterange[1], "MM/dd/yyyy") + '"'  + ',"MM/DD/YYYY")';

    }

    let data: any = [];
    let userId: number = 0;
    // if (this.adminuser == true) {
    //  userId = 0;
    // }
    // else {
    //  userId = this.userid;
    // }
    userId = this.userid;
    // if (this.conversionuser == false) {
    //  if (this.adminuser == true) {
    //    userId = 0;
    //  }
    //  else {
    //    userId = this.userid;
    //  }
    // }
    // else {
    //  userId = 0;
    // }




    var searchConditiontmp = '';
    if (this.searchCondition != '')
      searchConditiontmp = this.searchCondition;
    else
      searchConditiontmp = null;
    var sortConditiontmp = '';
    if (this.sortCondition != '')
      sortConditiontmp = this.sortCondition;
    else
      sortConditiontmp = null;

    var businessunitId = 0;

    if (this.businessunitid > 0) {
      businessunitId = this.businessunitid;
    }
    else {
      businessunitId = 0;
    }

    var productitId = 0;

    if (this.productId > 0) {
      productitId = this.productId;
    }
    else {
      productitId = 0;
    }
    // data.push({
    //  requesttype: 0,
    //  status: 0, active: 0, mode: 'getcount', requeststatus: this.selectedRequestType, dbid: databaseId, userid: userId, searchcondition: searchConditiontmp, sorting: sortConditiontmp,
    // });
    data.push({
      requesttype: 0,
      status: 0, active: 0, mode: 'getcount', requeststatus: this.selectedRequestType, dbid: databaseId, userid: userId, searchcondition: searchConditiontmp,
      sorting: sortConditiontmp, businessunitid: businessunitId, productid: productitId, daterange: dateRange

    });
    this.requestdashboardservice.getRequestDashboardCount(data[0]).subscribe(res => {
      if (res != undefined && res != null && res.body.count != undefined && res.body.count != null) {
        this.totalRequestCount = res.body.count;
        if (this.totalRequestCount > 0) {
          let input: any = [];
          // input.push({
          //  requesttype: 0, status: 0, active: 0, mode: 'getall', pageno: pagenumber, itemsperpage: this.itemsPerPage, searchcondition: searchConditiontmp, sorting: sortConditiontmp,
          //  requeststatus: this.selectedRequestType, dbid: databaseId, userid: userId
          // });
          input.push({
            requesttype: 0, status: 0, active: 0, mode: 'getall', pageno: pagenumber, itemsperpage: this.itemsPerPage, searchcondition: searchConditiontmp, sorting: sortConditiontmp,
            requeststatus: this.selectedRequestType, dbid: databaseId, userid: userId, businessunitid: businessunitId, productid: productitId, daterange: dateRange

          });
          this.requestdashboardservice.getRequestDashboardDetails(input[0]).subscribe(res => {
                        this.requestlisttmp = [];
            this.requestlisttmp = res.body;
            // if (this.state != undefined && this.state != null && this.sortCondition != '') {
            //// this.requestlisttmp = this.requestlisttmp.reverse();
            // }
            if (type == 'closed') {
              this.requestlistClosed = [];
              this.requestlistClosed = this.requestlisttmp;
              this.SpinnerService.hide();
            }
            if (type == 'cancelled') {
              this.requestlistCancelled = [];
              this.requestlistCancelled = this.requestlisttmp;
              this.SpinnerService.hide();
            }
            if (type == 'others') {
              this.requestlisttmp.forEach(item => {
                var usercheck = 'no';
                var supportusercheck = 'no';
                if (item.pickedbyuserid == this.userid) {
                  usercheck = 'yes';
                }
                if (item.supportpickedbyuserid == this.userid) {
                  supportusercheck = 'yes';
                }

                item["pickbyusercheck"] = usercheck;
                item["supportusercheck"] = supportusercheck;
              });
              this.requestlistOthers = [];
              this.requestlistOthers = this.requestlisttmp;
			   // this.requestlistOthers_SearchAll = this.requestlisttmp;
              this.SpinnerService.hide();
            }
            if (type == 'allrequests') {
              this.allrequestlist = [];
              this.allrequestlist = this.requestlisttmp;
              this.SpinnerService.hide();
            }

            if (this.columnshow == true && this.state != undefined && this.state != null) {
              if (this.searchConditionList.length != 0) {
                this.searchConditionList.forEach(i => {
                  $("#columnsearch_" + i.columnName)[0].value = i.value;
                });
              }
            }

          },
            err => {
              this.toastr.error('Not able to get request data');
              this.SpinnerService.hide();
            });
        }
        else {
          // this.columnshow = false;
          this.requestlistCancelled = [];
          this.requestlistOthers = [];
          this.requestlistClosed = [];
          this.allrequestlist = [];
          this.SpinnerService.hide();
        }
      }
    }, err => {
      this.toastr.error(err);
      this.toastr.error('Not able to get request data');
      this.SpinnerService.hide();
    });
  }


  

  columnsearchshowhide() {
    if (this.columnshow == true)
      this.columnshow = false;
    else
      this.columnshow = true;
  }

  columnsearchchanged() {
    let columnheaders: any = [];
    var searchCondition = '';
    var requestListDetails = [];
    if (this.selectedRequestType == 'others') {
      if (this.requestlistOthers != undefined && this.requestlistOthers != null && this.requestlistOthers.length != 0) {
        requestListDetails = this.requestlistOthers;
      }
      columnheaders = this.headerKeyOthers;// add this line
    }
    if (this.selectedRequestType == 'closed') {
      if (this.requestlistClosed != undefined && this.requestlistClosed != null && this.requestlistClosed.length != 0) {
        requestListDetails = this.requestlistClosed; // add this line
      }
      columnheaders = this.headerKeyClosed;
    }
    if (this.selectedRequestType == 'cancelled') {
      if (this.requestlistCancelled != undefined && this.requestlistCancelled != null && this.requestlistCancelled.length != 0) {
        requestListDetails = this.requestlistCancelled;
      }
      columnheaders = this.headerKeyOthers;// add this line
    }
    if (this.selectedRequestType == 'allrequests') {
      if (this.allrequestlist != undefined && this.allrequestlist != null && this.allrequestlist.length != 0) {
        requestListDetails = this.allrequestlist;
      }
      columnheaders = this.headerKeyOthers;// add this line
    }

    // if (this.selectedRequestType == 'others') {
    //  if (this.requestlistOthers != undefined && this.requestlistOthers != null && this.requestlistOthers.length != 0) {
    //    requestListDetails = this.requestlistOthers;
    //  }
    // }
    // if (this.selectedRequestType == 'closed') {
    //  if (this.requestlistClosed != undefined && this.requestlistClosed != null && this.requestlistClosed.length != 0) {
    //    requestListDetails = this.requestlistClosed;
    //  }
    // }
    // if (this.selectedRequestType == 'cancelled') {
    //  if (this.requestlistCancelled != undefined && this.requestlistCancelled != null && this.requestlistCancelled.length != 0) {
    //    requestListDetails = this.requestlistCancelled;
    //  }
    // }
    // if (requestListDetails.length != 0) {
    //  columnheaders = Object.keys(requestListDetails[0]);
    this.searchConditionList = [];
    for (var col of columnheaders) {
      col = col.toLowerCase();
      if ($("#columnsearch_" + col).val() != undefined && $("#columnsearch_" + col).val() != '') {
        this.searchConditionList.push({
          columnName: col,
          value: $("#columnsearch_" + col).val()
        });
        if (col == 'desiredcompletiondate' || col == 'createdonformatted') {
          var s = $("#columnsearch_" + col).val().split('-');
          if (col == 'createdonformatted') {

          /*  if (searchCondition == '') {
              // searchCondition = 'to_char(lower(l.' + col + '):: timestamp, "mm/dd/yyyy")' + ' between "' + s[0].trim() + '"' + ' and ' + '"' + s[1].trim() + '"';
              searchCondition = 'cast(lower(l.' + col + ') as date)' + ' between "' + s[0].trim() + '"' + ' and ' + '"' + s[1].trim() + '"';
            }
            else {
              searchCondition = searchCondition + ' and ' + 'cast(lower(l.' + col + ') as date)' + ' between "' + s[0].trim() + '"' + ' and ' + '"' + s[1].trim() + '"';
              // searchCondition = searchCondition + ' and ' + 'to_char(lower(l.' + col + '):: timestamp, "mm/dd/yyyy")' + ' between "' + s[0].trim() + '"' + ' and ' + '"' + s[1].trim() + '"';
            }*/
            if (searchCondition == '') {
              searchCondition = 'lower(l.' + col + ')' + ' between "' + s[0].trim() + '"' + ' and ' + '"' + s[1].trim() + '"';
            }
            else {
              searchCondition = searchCondition + ' and ' + 'lower(l.' + col + ')' + ' between "' + s[0].trim() + '"' + ' and ' + '"' + s[1].trim() + '"';
            }
          }
          if (col == 'desiredcompletiondate') {
            if (searchCondition == '') {
              searchCondition = 'lower(l.' + col + ')' + ' between "' + s[0].trim() + '"' + ' and ' + '"' + s[1].trim() + '"';
            }
            else {
              searchCondition = searchCondition + ' and ' + 'lower(l.' + col + ')' + ' between "' + s[0].trim() + '"' + ' and ' + '"' + s[1].trim() + '"';
            }
          }

        } else if (col == 'samedayturnaround') {
          var samedaysearchval = $("#columnsearch_" + col).val().toLowerCase();
          if (samedaysearchval == 'n' || samedaysearchval == 'o' || samedaysearchval == 'no') {
            var samedayturnaroundVal = 0;
          }
          else if (samedaysearchval === 'y' || samedaysearchval == 'e' || samedaysearchval == 's' || samedaysearchval == 'ye' || samedaysearchval == 'es' || samedaysearchval == 'yes') {
            var samedayturnaroundVal = 1;
          }
          else {
            var samedayturnaroundVal = 2;
          }

          if (searchCondition == '') {
            searchCondition = 'cast(l.' + col + ' as TEXT) like \'%' + samedayturnaroundVal + '%\'';
          }
          else {
            searchCondition = searchCondition + ' and ' + 'cast(l.' + col + ' as TEXT) like \'%' + samedayturnaroundVal + '%\'';
          }

          // searchCondition = 'cast(l.' + col + ' as TEXT) like \'%' + samedayturnaroundVal + '%\'';
        }
        else {
          if (searchCondition == '') {
            searchCondition = 'lower(l.' + col + ')' + ' like "%' + $("#columnsearch_" + col).val().replace('\'', '\'\'').trim().toLowerCase() + '%"';
          }
          else {
            searchCondition = searchCondition + ' and ' + 'lower(l.' + col + ')' + ' like "%' + $("#columnsearch_" + col).val().replace('\'', '\'\'').trim().toLowerCase() + '%"';
          }


        }
      }
    }
    if (searchCondition != '') {
      this.searchCondition = searchCondition;
      this.getRequestDetails(this.selectedRequestType, 0);
    }
    else {
      this.searchCondition = '';
      this.getRequestDetails(this.selectedRequestType, 0);
    }
    // }
  }


  
  



  columnsearchcancel() {
    this.columnshow = false;
    this.dt1 = [];
    this.dt = [];
    this.getRequestDetails(this.selectedRequestType, 0);
  }

 

  keypress(eve) {
    if (eve.keyCode == 13) {
      this.columnsearchchanged();
    }
  }
  updateMyDate(eve) {
    
    this.columnsearchchanged();
  }

 

  addrequest() {
    let queryParams = {};
    const navigationExtras: NavigationExtras = {
      queryParams,
      state: {
        selectedDataBase: this.databaseId,
        userType: this.adminuser,
        selectedColumnShow: this.columnshow,
        selectedReqType: this.selectedRequestType,
        selectedPageNumber: this._pageNumber,
        selectedItemsPerPage: this.itemsPerPage,
        selectedSearchCondition: this.searchCondition,
        selectedSortCondition: this.sortCondition,
        selectedSearchConditionList: JSON.stringify(this.searchConditionList)
      }
    };
    this.router.navigate(['/home/requestconfig'], navigationExtras);
  }

  keypresspage(eve) {
    var charCode = (eve.which) ? eve.which : eve.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    if (eve.keyCode == 13) {
      this.getPage(eve.target.value);
    }
  }


 
  productchange(event) {

    this.productId = event.target.value;
    var selectedValue = event.target.value;

    this.getRequestDetails(this.selectedRequestType, 0);

  }
  getProducts() {
    this.productService.GetActive().subscribe(res => {
      this.productsList = res;

    }, err => { this.toastr.error('Error While Getting Product Data'); });
  }
  refreshPage() {
    // this.ngOnInit();
    this.getRequestDetails(this.selectedRequestType, 0);
  }

  downloadAllFields(template: TemplateRef<any>) {
    this.selReqType = 0;
    this.reqtypeModelRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove('modal-content');
  }
  
  
 

  getAllFields(type) {  
    // this.selectedRequestType = data;
     if (this.selReqType != 0) {
      // this.selectedRequestType = data;
      this.ExportTOExcel(type);
      this.reqtypeModelRef.hide();
    } else {
      this.toastr.warning('Please select any request type');
    }

  }
  async getpagepreference() {
    let model = {
      //userid: +localStorage.getItem('userid'),
      useriid: +this.localService.getJsonValue('userid'),
      pagename: 'requestdashboard'
    };
    await this.formdashboardservice.getpagepreferencedetails(model).toPromise().then(res => {
      console.log('res: ', res);
      if (res != null) {
        let data = JSON.parse(res[0].j);
        this.itemsPerPage = data[0].itemsperpage == undefined || data[0].itemsperpage == null ? this.itemsPerPage : data[0].itemsperpage;
      }

    });
  }



  addpagepreference(value) {
    let model = {
      //userid: +localStorage.getItem('userid'),
      userid: +this.localService.getJsonValue('userid'),
      pagename: 'requestdashboard',
      itemsperpage: value
    };

    this.formdashboardservice.addpagepreferencedetails(model).toPromise().then(res => {
      console.log('res: ', res);

    });
  }

  
  columnsearchchanged_searchAll() {   
    
    let columnheaders: any = [];
    var searchCondition = '';
    var requestListDetails = [];
    this.searchCondition_searchall = '';
    

    requestListDetails= this.requestlistOthers_SearchAll;

if (requestListDetails.length != 0) {
      columnheaders = Object.keys(requestListDetails[0]);

    this.searchConditionList = [];
    for (var col of columnheaders) {
      col = col.toLowerCase();
      if ($("#columnsearch_SearchAll_" + col).val() != undefined && $("#columnsearch_SearchAll_" + col).val() != '') {
        this.searchConditionList.push({
          columnName: col,
          value: $("#columnsearch_SearchAll_" + col).val()
        });
        if (col == 'desiredcompletiondate' || col == 'createdonformatted') {
          var s = $("#columnsearch_SearchAll_" + col).val().split('-');
          if (col == 'createdonformatted') {

        /*    if (searchCondition == '') {
              // searchCondition = 'to_char(lower(l.' + col + '):: timestamp, "mm/dd/yyyy")' + ' between "' + s[0].trim() + '"' + ' and ' + '"' + s[1].trim() + '"';
              searchCondition = 'cast(lower(l.' + col + ') as date)' + ' between "' + s[0].trim() + '"' + ' and ' + '"' + s[1].trim() + '"';
            }
            else {
              searchCondition = searchCondition + ' and ' + 'cast(lower(l.' + col + ') as date)' + ' between "' + s[0].trim() + '"' + ' and ' + '"' + s[1].trim() + '"';
              // searchCondition = searchCondition + ' and ' + 'to_char(lower(l.' + col + '):: timestamp, "mm/dd/yyyy")' + ' between "' + s[0].trim() + '"' + ' and ' + '"' + s[1].trim() + '"';
            }*/
            if (searchCondition == '') {
              searchCondition = 'lower(l.' + col + ')' + ' between "' + s[0].trim() + '"' + ' and ' + '"' + s[1].trim() + '"';
            }
            else {
              searchCondition = searchCondition + ' and ' + 'lower(l.' + col + ')' + ' between "' + s[0].trim() + '"' + ' and ' + '"' + s[1].trim() + '"';
            }
          }
          if (col == 'desiredcompletiondate') {
            if (searchCondition == '') {
              searchCondition = 'lower(l.' + col + ')' + ' between "' + s[0].trim() + '"' + ' and ' + '"' + s[1].trim() + '"';
            }
            else {
              searchCondition = searchCondition + ' and ' + 'lower(l.' + col + ')' + ' between "' + s[0].trim() + '"' + ' and ' + '"' + s[1].trim() + '"';
            }
          }

        } else if (col == 'samedayturnaround') {
          var samedaysearchval = $("#columnsearch_SearchAll_" + col).val().toLowerCase();
          if (samedaysearchval == 'n' || samedaysearchval == 'o' || samedaysearchval == 'no') {
            var samedayturnaroundVal = 0;
          }
          else if (samedaysearchval === 'y' || samedaysearchval == 'e' || samedaysearchval == 's' || samedaysearchval == 'ye' || samedaysearchval == 'es' || samedaysearchval == 'yes') {
            var samedayturnaroundVal = 1;
          }
          else {
            var samedayturnaroundVal = 2;
          }

          if (searchCondition == '') {
            searchCondition = 'cast(l.' + col + ' as TEXT) like \'%' + samedayturnaroundVal + '%\'';
          }
          else {
            searchCondition = searchCondition + ' and ' + 'cast(l.' + col + ' as TEXT) like \'%' + samedayturnaroundVal + '%\'';
          }

          // searchCondition = 'cast(l.' + col + ' as TEXT) like \'%' + samedayturnaroundVal + '%\'';
        }
        else {
          if (searchCondition == '') {
            searchCondition = 'lower(l.' + col + ')' + ' like "%' + $("#columnsearch_SearchAll_" + col).val().replace('\'', '\'\'').trim().toLowerCase() + '%"';
          }
          else {
            searchCondition = searchCondition + ' and ' + 'lower(l.' + col + ')' + ' like "%' + $("#columnsearch_SearchAll_" + col).val().replace('\'', '\'\'').trim().toLowerCase() + '%"';
          }


        }
      }
    }

    
      if (this.searchTextforDatabase != undefined && this.searchTextforDatabase != '') {

        if (searchCondition == '') {
          searchCondition = 'lower(l.' + 'document' + ')' + ' like "%' + this.searchTextforDatabase.replace('\'', '\'\'').trim().toLowerCase() + '%"';
        }
        else {
          searchCondition = searchCondition + ' and ' + 'lower(l.' + 'document' + ')' + ' like "%' + this.searchTextforDatabase.replace('\'', '\'\'').trim().toLowerCase() + '%"';
        }

      }
    

    if (searchCondition != '') {
      this.searchCondition_searchall = searchCondition;
      this.getRequestDetails_SearchAll('allrequests', 0);
    }
    else {
      this.searchCondition_searchall = '';
      this.getRequestDetails_SearchAll('allrequests', 0);
    }
    // }
  }
  }

  columnsearchcancel_SearchAll() {
    this.columnshow_searchall = false;
    //this.dt1 = [];
    //this.dt = [];
    this.dt1_searchall = [];
    this.dt_searchall = [];
    this.getRequestDetails_SearchAll('allrequests', 0);
  }

  keypress_searchAll(eve) {
    if (eve.keyCode == 13) {
      this.columnsearchchanged_searchAll();
    }
  }
  updateMyDate_searchAll(eve) {
    this.columnsearchchanged_searchAll();
  }

  keypresspage_searchall(eve) {
    var charCode = (eve.which) ? eve.which : eve.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    if (eve.keyCode == 13) {
      this.getPage_searchall(eve.target.value);
    }
  }

  OpenSearchallReq(template: TemplateRef<any>) {
    
    this.selReqType = 0;
    this.SearchAllReqRef = this.modalService.show(template, this.config);
     const aa = document.getElementsByClassName('modal-content');
     aa[0].classList.remove('modal-content');

     this.getRequestDetails_SearchAll('allrequests', 0);

  }

  selectedRequestDateRange_searchall(eve) {
    this.selectedDaterange_searchall = eve;
    this.getRequestDetails_SearchAll('allrequests', 0);
  }
  removeDateRange_searchall() {
    this.removedaterangeflag_searchall = true;
    this.selectedDaterange_searchall = [];
    this.getRequestDetails_SearchAll('allrequests', 0);
  }


  getRequestDetails_SearchAll(type, tabflag) {
    
    this.SpinnerService.show();
    // type='allrequests';
   // console.log(this.selectedRequestType);
  /* if (this.selectedRequestType != '') {   
     if (this.selectedRequestType != type) {
       this.searchCondition_searchall = '';
       this.sortCondition = '';
       this.columnshow_searchall = false;
        this.searchConditionList = [];
        this.p_searchall = 1; 
        this.q = 1; this.r = 1;
        this.s = 1;
      }
    }*/
    //this.p_searchall = 1; 
    this.q = 1; this.r = 1;
    this.s = 1;
      if (this.columnshow_searchall == false) {
        this.searchCondition_searchall = '';
        this.searchConditionList = [];
      }
    

    if (this.searchTextforDatabase != undefined && this.searchTextforDatabase != '') {

      if (this.searchCondition_searchall == '') {
        this.searchCondition_searchall = 'lower(l.' + 'document' + ')' + ' like "%' + this.searchTextforDatabase.replace('\'', '\'\'').trim().toLowerCase() + '%"';
      }
      else {
        this.searchCondition_searchall = this.searchCondition_searchall + ' and ' + 'lower(l.' + 'document' + ')' + ' like "%' + this.searchTextforDatabase.replace('\'', '\'\'').trim().toLowerCase() + '%"';
      }

    }

    // this.selectedRequestType = '';
   // this.selectedRequestType = type;
    if (tabflag == 1) {
      if (type == 'closed') {
        this.selectedDaterange_searchall = [new Date(new Date().setMonth(this.todaydate.getMonth() - 3)), this.todaydate];
        this.removedaterangeflag_searchall == false;
      }
      else
        this.selectedDaterange_searchall = null;
    }



    var pagenumber = 0; var databaseId = 0;
    if (type == 'others') {
      pagenumber = this.p_searchall;
      this.tabs.select('OthersRequestList');
    }
    else if (type == 'closed') {
      pagenumber = this.q;
      this.tabs.select('ClosedRequestList');
      if (this.removedaterangeflag_searchall == true && tabflag == 0)
        this.selectedDaterange_searchall = null;
      else {
        if (tabflag == 1)
          this.selectedDaterange_searchall = [new Date(new Date().setMonth(this.todaydate.getMonth() - 3)), this.todaydate];
      }
    } else if (type == 'allrequests') {
      pagenumber =this.p_searchall;//this.s;
      this.tabs.select('AllRequestList');
    }
    else {
      pagenumber = this.r;
      this.tabs.select('CancelledRequestList');
    }
    this._pageNumber = pagenumber;
    if (this.databaseId_Searchall > 0) {
      databaseId = this.databaseId_Searchall;
    }
    else {
      databaseId = 0;
    }

    var dateRange = '';
    if (this.selectedDaterange_searchall != undefined && this.selectedDaterange_searchall.length != 0) {
      // daterange = 'to_char(l.createdon:: timestamp, "mm/dd/yyyy") between ' + '"' + this.datePipe.transform(this.selectedDaterange[0], "MM/dd/yyyy") + '"' + ' and ' + '"' + this.datePipe.transform(this.selectedDaterange[1], "MM/dd/yyyy") + '"';
      dateRange = ' to_char(cast(l.createdon as date),"MM/DD/YYYY") between ' + '"' + this.datePipe.transform(this.selectedDaterange_searchall[0], "MM/dd/yyyy") + '"' + ' and ' + '"' + this.datePipe.transform(this.selectedDaterange_searchall[1], "MM/dd/yyyy") + '"';

    }

    let data: any = [];
    let userId: number = 0;
    // if (this.adminuser == true) {
    //  userId = 0;
    // }
    // else {
    //  userId = this.userid;
    // }
    userId = this.userid;
    // if (this.conversionuser == false) {
    //  if (this.adminuser == true) {
    //    userId = 0;
    //  }
    //  else {
    //    userId = this.userid;
    //  }
    // }
    // else {
    //  userId = 0;
    // }




    var searchConditiontmp = '';
    if (this.searchCondition_searchall != '')
      searchConditiontmp = this.searchCondition_searchall;
    else
      searchConditiontmp = null;
    var sortConditiontmp = '';
    if (this.sortCondition_searchall != '')
      sortConditiontmp = this.sortCondition_searchall;
    else
      sortConditiontmp = null;

    var businessunitId = 0;

    if (this.businessunitId_Searchall > 0) {
      businessunitId = this.businessunitId_Searchall;
    }
    else {
      businessunitId = 0;
    }

    var productitId = 0;

    if (this.productId_Searchall > 0) {
      productitId = this.productId_Searchall;
    }
    else {
      productitId = 0;
    }
    // data.push({
    //  requesttype: 0,
    //  status: 0, active: 0, mode: 'getcount', requeststatus: this.selectedRequestType, dbid: databaseId, userid: userId, searchcondition: searchConditiontmp, sorting: sortConditiontmp,
    // });
    
    console.log(dateRange);
    data.push({
      requesttype: 0,
      status: 0, active: 0, mode: 'getcount', requeststatus: type, dbid: databaseId, userid: userId, searchcondition: searchConditiontmp,
      sorting: sortConditiontmp, businessunitid: businessunitId, productid: productitId, daterange: dateRange

    });
    this.requestdashboardservice.getRequestDashboardCount(data[0]).subscribe(res => {
      if (res != undefined && res != null && res.body.count != undefined && res.body.count != null) {
        this.totalRequestCount_searchall = res.body.count;
        console.log(this.totalRequestCount_searchall);
        if (this.totalRequestCount_searchall > 0) {
          let input: any = [];
          // input.push({
          //  requesttype: 0, status: 0, active: 0, mode: 'getall', pageno: pagenumber, itemsperpage: this.itemsPerPage, searchcondition: searchConditiontmp, sorting: sortConditiontmp,
          //  requeststatus: this.selectedRequestType, dbid: databaseId, userid: userId
          // });
          input.push({
            requesttype: 0, status: 0, active: 0, mode: 'getall', pageno: pagenumber, itemsperpage: this.itemsPerPage, searchcondition: searchConditiontmp, sorting: sortConditiontmp,
            requeststatus: type, dbid: databaseId, userid: userId, businessunitid: businessunitId, productid: productitId, daterange: dateRange

          });
          this.requestdashboardservice.getRequestDashboardDetails(input[0]).subscribe(res => {
            this.requestlisttmp = [];
            this.requestlisttmp = res.body;
            // if (this.state != undefined && this.state != null && this.sortCondition != '') {
            //// this.requestlisttmp = this.requestlisttmp.reverse();
            // }
            if (type == 'closed') {
              this.requestlistClosed = [];
              this.requestlistClosed = this.requestlisttmp;										   
              this.SpinnerService.hide();
            }
			 if (type == 'cancelled') {
              this.requestlistCancelled = [];
              this.requestlistCancelled = this.requestlisttmp;
              this.SpinnerService.hide();
            }
            if (type == 'others') {
              this.requestlisttmp.forEach(item => {
                var usercheck = 'no';
                var supportusercheck = 'no';
                if (item.pickedbyuserid == this.userid) {
                  usercheck = 'yes';
                }
                if (item.supportpickedbyuserid == this.userid) {
                  supportusercheck = 'yes';
                }

                item["pickbyusercheck" ] = usercheck;
                item["supportusercheck"] = supportusercheck;
              });
              this.requestlistOthers_SearchAll = [];
             // console.log('óther');
              this.requestlistOthers_SearchAll = this.requestlisttmp;
            //  console.log(this.requestlistOthers_SearchAll);
            //  console.log(this.requestlistOthers);
              this.SpinnerService.hide();
            }			
              
            if (type == 'allrequests') {
            //  this.allrequestlist = [];
             // this.allrequestlist = this.requestlisttmp;
              this.requestlistOthers_SearchAll = [];
               
               this.requestlistOthers_SearchAll = this.requestlisttmp;
               console.log(this.requestlistOthers_SearchAll);
              this.SpinnerService.hide();
            }

            if (this.columnshow_searchall == true && this.state != undefined && this.state != null) {
              if (this.searchConditionList.length != 0) {
                this.searchConditionList.forEach(i => {
                  $("#columnsearch_" + i.columnName)[0].value = i.value;
                });
              }
            }

          },
            err => {
              this.toastr.error('Not able to get request data');
              this.SpinnerService.hide();
            });
        }
        else {
          // this.columnshow = false;
          this.requestlistCancelled = [];
          this.requestlistOthers_SearchAll = [];
          this.requestlistClosed = [];
          this.allrequestlist = [];
          this.SpinnerService.hide();
        }
      }
    }, err => {
      this.toastr.error('Not able to get request data');
      this.SpinnerService.hide();
    });
  }
  getPage_searchall(page: number){
    
    this.p_searchall=page;
    this.getRequestDetails_SearchAll('allrequests',0);
  }

  sort_SearchAllReq(key) {   
     
    if (this.key != key) {
      this.sortDirection_searchall = '';
      this.sortDirection_searchall = 'asc';
    }
    else {
      this.sortDirection_searchall = this.sortDirection_searchall === 'desc' ? 'asc' : 'desc';
    }
    this.key = key;
    this.reverse = !this.reverse;
    this.sortCondition_searchall = '';

    // this.sortCondition = 'l.' + this.key.toLowerCase() + ' ' + this.sortDirection;
    if (this.key == 'createdonformatted') {
      this.sortCondition_searchall = 'l.createdon' + ' ' + this.sortDirection_searchall;
    }
    else if (this.key == 'desiredcompletiondate'){
      this.sortCondition_searchall = 'l.desiredcompletiondatenotformated' + ' ' + this.sortDirection_searchall;
    }
    else {
      this.sortCondition_searchall = 'l.' + this.key.toLowerCase() + ' ' + this.sortDirection_searchall;
    }

    this.getRequestDetails_SearchAll('allrequests', 0);
  }

  Searchall() {
    this.getRequestDetails_SearchAll('allrequests', 0);
  }	
  
  columnsearchshowhide_searchall() {
    if (this.columnshow_searchall == true)
      this.columnshow_searchall = false;
    else
      this.columnshow_searchall = true;
  }

  SearchAllReqClose(){
    this.columnshow_searchall = false;
    this.p_searchall=1;
   this.sortCondition_searchall = '';
    this.productId_Searchall=0;
    this.businessunitId_Searchall=0;
    this.requestlistOthers_SearchAll = [];
    this.databaseId_Searchall=0;    
    this.removedaterangeflag_searchall = true;
    this.selectedDaterange_searchall = [];
    this.searchCondition_searchall='';
    this.searchTextforDatabase='';
    this.dt1_searchall = [];
    this.dt_searchall = [];
    this.SearchAllReqRef.hide();
  }
  viewrequest_searchall(request){
    let a = request.requestid + '*' + request.requesttypeid;
    let queryParams = {};
    queryParams['requestid'] = this.enc.encryptUsingAES256(request.requestid.toString());
    queryParams['requesttypeid'] = this.enc.encryptUsingAES256(request.requesttypeid.toString());
    queryParams['redirectmode'] = this.enc.encryptUsingAES256('viewrequest');    
    let url = this.router.createUrlTree(['/home/requestconfig'], { queryParams: queryParams });
    window.open('#' + url.toString(), '_blank');
  }

  statusupdate_searchall(request, status, redirect) {
    if (redirect == 'check') {
      if (request.pickedbyuserid == this.userid || request.supportpickedbyuserid == this.userid) {        
        let queryParams = {};
        queryParams['requestid'] =this.enc.encryptUsingAES256(request.requestid.toString());
        queryParams['requesttypeid'] = this.enc.encryptUsingAES256(request.requesttypeid.toString());
        if (this.supportuser && request.statusid == 15) {
          queryParams['redirectmode'] = this.enc.encryptUsingAES256('supportuser');
          queryParams['supportuser'] = this.enc.encryptUsingAES256(this.supportuser.toString());
        }
        else {
          queryParams['redirectmode'] = this.enc.encryptUsingAES256('conversionuser');
          queryParams['conversionuser'] = this.enc.encryptUsingAES256(this.conversionuser.toString());
        }
       /* const navigationExtras: NavigationExtras = {
          queryParams,
          state: {}
        };*/
       // this.router.navigate(['/home/requestconfig'], navigationExtras);
        let url = this.router.createUrlTree(['/home/requestconfig'], { queryParams: queryParams });
        window.open('#' + url.toString(), '_blank');								
      }
    }
    else {
      this.requeststatus.requestdetailid = request.requestid;
      this.requeststatus.requesttypeid = request.requesttypeid;
      this.requeststatus.active = 1;
      this.requeststatus.statusid = status;
      this.requeststatus.createdby = this.userid;     
      this.requestdashboardservice.Post(this.requeststatus).subscribe(
        (res) => {
          if (res.body != 0) {
            if (redirect == 'yes') {
              let queryParams = {};
              queryParams['requestid'] = this.enc.encryptUsingAES256(request.requestid.toString());
              queryParams['requesttypeid'] = this.enc.encryptUsingAES256(request.requesttypeid.toString());           
             if ((request.statusid === 16 && this.conversionuser && request.supportusercheckcount == 1 && request.supportusercheckrequestcount == 0) || (request.statusid === 1 && this.conversionuser && request.supportusercheckrequestcount == 0) || (request.statusid === 16 && this.conversionuser && request.supportusercheckcount == 1 && request.supportusercheckrequestcount == 1) || request.statusid == 4) {
                queryParams['redirectmode'] = this.enc.encryptUsingAES256('conversionuser');
                queryParams['conversionuser'] = this.enc.encryptUsingAES256(this.conversionuser.toString());
              } else {
                queryParams['redirectmode'] =this.enc.encryptUsingAES256('supportuser');
                queryParams['supportuser'] = this.enc.encryptUsingAES256(this.supportuser.toString());
              }
            /*  const navigationExtras: NavigationExtras = {
                queryParams,
                state: {             
                }
              };*/
              let url = this.router.createUrlTree(['/home/requestconfig'], { queryParams: queryParams });
              window.open('#' + url.toString(), '_blank');	
             // this.router.navigate(['/home/requestconfig'], navigationExtras);
			}
            else if (redirect == 'reopen') {
              let queryParams = {};
              queryParams['requestid'] = this.enc.encryptUsingAES256(request.requestid.toString());
              queryParams['requesttypeid'] = this.enc.encryptUsingAES256(request.requesttypeid.toString());
              queryParams['redirectmode'] = this.enc.encryptUsingAES256('normaluser');
             /* const navigationExtras: NavigationExtras = {
                queryParams,
                state: {
                               }
              };*/
             // this.router.navigate(['/home/requestconfig'], navigationExtras);						  
             let url = this.router.createUrlTree(['/home/requestconfig'], { queryParams: queryParams });
             window.open('#' + url.toString(), '_blank');
            }
            else {
              this.requestlist = [];
              this.requestlistClosed = [];
              this.requestlistCancelled = [];
              this.requestlistOthers = [];
              this.requestlisttmp = [];
              var dbid = $("#dbid option:selected").val();             
              this.getRequestDetails(this.selectedRequestType, 0);
            }
          }
        }, error => {
          this.toastr.error("Error while updating status");          
        });
    }
  }

  editRequest_searchall(request) {

    let a = request.requestid + '*' + request.requesttypeid;
    let queryParams = {};   
    queryParams['requestid'] = this.enc.encryptUsingAES256(request.requestid.toString());//request.requestid;
    queryParams['requesttypeid'] = this.enc.encryptUsingAES256(request.requesttypeid.toString());//request.requesttypeid;
    queryParams['redirectmode'] =this.enc.encryptUsingAES256('normaluser');// 'normaluser';
    let url = this.router.createUrlTree(['/home/requestconfig'], { queryParams: queryParams });
    window.open('#' + url.toString(), '_blank');				

  }
}


